import React from 'react';
import { ISelectField } from './interfaces';
import { FormField } from '../FormField';
import { MenuItem, Select, SelectChangeEvent, Stack } from '@mui/material';
import { ClearFieldButton } from '../ClearFieldButton';

export const SelectField: React.FC<ISelectField> = ({
  name,
  label,
  helperText,
  required,
  error,
  value,
  disabled,
  placeholder,
  children,
  onChange,
}): JSX.Element => {
  return (
    <FormField
      label={label}
      helperText={helperText}
      required={required}
      error={error}
    >
      <ClearFieldButton onClear={() => onChange('')} show={!!value}>
        <Select
          size="small"
          labelId={`${name}-select-label`}
          value={value ? String(value) : '-'}
          onChange={(event: SelectChangeEvent) => {
            onChange(event.target.value);
          }}
          error={!!error}
          required={required}
          disabled={disabled}
          sx={{
            backgroundColor: '#FFF',
          }}
          fullWidth
        >
          {placeholder && (
            <MenuItem disabled value="-">
              <em>{placeholder}</em>
            </MenuItem>
          )}
          {children}
        </Select>
      </ClearFieldButton>
    </FormField>
  );
};
